import React, { useCallback, useMemo, useState, useEffect } from "react";
import { loadStripe } from '@stripe/stripe-js';
import { Card, Container, Typography } from '@mui/material';
import {
    EmbeddedCheckoutProvider,
    EmbeddedCheckout
} from '@stripe/react-stripe-js';

import { useCreateSessionQuery } from 'services/subscription';


// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
// const stripePromise = loadStripe('pk_test_51Km1tODNmbv6NMIxzTcouHjiA2a2gp7EAQhR8AuRR3Yb7Ybieafguesv59Ik4z9h4JMJfpSeRIeFn4MxhP4PJqDy00e8zFCwP1', {
// });

const stripePromise = loadStripe('pk_live_51Km1tODNmbv6NMIxvqPJ5YWHPOgPDRMJUHMecoLaJoeReIvbhpQvUjstUyoVy31Zi37wPN8ZZ6D5iRQkXO65trrL00YEGEICxO', {});

const PaymentMain = () => {

    const userDetails = JSON.parse(localStorage.getItem('tirefaxUserDetails'));

    const { result, activeLoading, fetching } = useCreateSessionQuery({
        customer_email: userDetails?.email,
    },
        {
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                result: data || '',
                activeLoading: isLoading,
                fetching: isFetching
            })
        }
    );

    const appearance = {
        theme: 'flat',
        variables: { colorPrimaryText: '#262626' }
    };

    const options = {
        clientSecret: result.client_secret,
    };

    return (
        <React.Fragment>
            {result !== '' ?
                <Container sx={{ paddingTop: '25px' }}>

                    <EmbeddedCheckoutProvider
                        stripe={stripePromise}
                        options={options}
                    >
                        <EmbeddedCheckout />
                    </EmbeddedCheckoutProvider>
                </Container>
                :
                <Card><Typography>Loading</Typography></Card>
            }
        </React.Fragment >
    )

}

export default PaymentMain;